import { Box, Button, Card, Image, Text } from '@zillow/constellation-10';
// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
import { styled } from '@/styled-system/jsx';

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const FacebookAdPreviewCard = styled(Card, {
  base: {
    padding: '0 !important',
    overflow: 'hidden',
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 300px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
    minWidth: '300px',
    '& img': {
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 300px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
      maxWidth: '300px',
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 300px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
      minWidth: '300px',
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxHeight: 300px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
      maxHeight: '300px',
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minHeight: 300px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
      minHeight: '300px',
      objectFit: 'cover',
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const LearnMoreButton = styled(Button, {
  base: {
    '&, &:focus, &:active, &:hover, & span': {
      backgroundColor: '#e4e6eb !important',
      color: 'black !important',
      border: 'none !important',
      boxShadow: 'none !important',
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const EllipsisText = styled(Text, {
  base: {
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 140px` falls between `2600` (104px) and `3600` (144px) on the numeric sizes scale
    maxWidth: '140px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const FacebookAdPreview = ({
  imageUrl,
  address,
  title,
}: {
  imageUrl: string;
  address: string;
  title: string;
}) => (
  <FacebookAdPreviewCard elevated={false} className="facebook-preview">
    <Image src={imageUrl} />
    <Box style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 16px' }}>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '100' }}>
        <EllipsisText textStyle="body-bold">{title}</EllipsisText>
        <EllipsisText
          textStyle="body-xs"
          css={{
            color:
              'gray.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          }}
        >
          {address}
        </EllipsisText>
      </Box>
      <LearnMoreButton>Learn More</LearnMoreButton>
    </Box>
  </FacebookAdPreviewCard>
);
